import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type StateService from 'garaje/services/state';
import { GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST } from 'garaje/utils/roles';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

const CAN_REVIEW_ROLES = [GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST];

export default class PreRegistrationRequiredAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;

  get canEnable(): boolean {
    if (!this.state.vrSubscription?.canAccessPreRegistrationRequired) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_LOCATION_CONFIG_UPDATE_INVITES);
  }

  get canReview(): boolean {
    const { roleNames } = this.currentAdmin;
    return isPresent(_intersection(CAN_REVIEW_ROLES, roleNames));
  }
}
